export default (entities) => ({
  getProjects({ page, status }) {
    return entities.Project.findAll({ page, status });
  },
});
